import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIncognitoFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.54002 5.37L4.19959 9.4H2.00002C1.66865 9.4 1.40002 9.66863 1.40002 10C1.40002 10.3314 1.66865 10.6 2.00002 10.6H22C22.3314 10.6 22.6 10.3314 22.6 10C22.6 9.66863 22.3314 9.4 22 9.4H19.8005L18.46 5.37C18.19 4.55 17.42 4 16.56 4H7.44002C6.58002 4 5.82002 4.55 5.54002 5.37ZM6.5 20C8.22842 20 9.66422 18.7471 9.94877 17.1H10H14H14.0512C14.3358 18.7471 15.7716 20 17.5 20C19.433 20 21 18.433 21 16.5C21 14.567 19.433 13 17.5 13C15.7716 13 14.3358 14.2529 14.0512 15.9H14H10H9.94877C9.66422 14.2529 8.22842 13 6.5 13C4.567 13 3 14.567 3 16.5C3 18.433 4.567 20 6.5 20Z",
		fill: "currentColor"
	})
});
export default SvgIncognitoFill;
